/**
 * AskCorvana — ambient AI helper that lives on every card. Click the sparkle to
 * get a contextual Corvana insight + a suggested action. Two shapes: a labelled
 * pill (default) and an icon-only chip for tight spots (KPI tiles).
 */
import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Sparkles, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

export default function AskCorvana({ insight, action, iconOnly = false, testid = 'ask-corvana' }) {
  const body = insight || 'Corvana is watching this metric live and will flag anything that needs your attention.';
  return (
    <Popover>
      <PopoverTrigger asChild>
        {iconOnly ? (
          <button
            data-testid={testid}
            aria-label="Ask Corvana"
            className="inline-grid place-items-center h-6 w-6 rounded-full text-emerald-600 hover:bg-emerald-50 transition-colors"
          >
            <Sparkles className="w-3.5 h-3.5" />
          </button>
        ) : (
          <button
            data-testid={testid}
            className="inline-flex items-center gap-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-100 px-2 py-0.5 text-[11px] font-semibold transition-colors"
          >
            <Sparkles className="w-3 h-3" /> Ask Corvana
          </button>
        )}
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 p-0 overflow-hidden" data-testid="ask-corvana-popover">
        <div className="bg-gradient-to-br from-emerald-600 to-teal-500 text-white px-3.5 py-2.5 flex items-center gap-1.5">
          <Sparkles className="w-4 h-4" />
          <span className="text-sm font-semibold">Corvana AI</span>
        </div>
        <div className="p-3.5">
          <p className="text-xs text-slate-700 leading-relaxed">{body}</p>
          <button
            onClick={() => toast.success('Corvana', { description: action || 'Action queued for your team.' })}
            className="mt-3 w-full inline-flex items-center justify-center gap-1.5 rounded-lg bg-slate-900 text-white text-xs font-semibold py-2 hover:bg-slate-800 transition-colors"
          >
            {action || 'Apply suggestion'} <ArrowRight className="w-3.5 h-3.5" />
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
